var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopupTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 34,
    rx: 17,
    fill: "#0040BF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.5C12.2016 6.5 7.5 11.2016 7.5 17C7.5 22.7984 12.2016 27.5 18 27.5C23.7984 27.5 28.5 22.7984 28.5 17C28.5 11.2016 23.7984 6.5 18 6.5ZM22.5 17.5625C22.5 17.6656 22.4156 17.75 22.3125 17.75H18.75V21.3125C18.75 21.4156 18.6656 21.5 18.5625 21.5H17.4375C17.3344 21.5 17.25 21.4156 17.25 21.3125V17.75H13.6875C13.5844 17.75 13.5 17.6656 13.5 17.5625V16.4375C13.5 16.3344 13.5844 16.25 13.6875 16.25H17.25V12.6875C17.25 12.5844 17.3344 12.5 17.4375 12.5H18.5625C18.6656 12.5 18.75 12.5844 18.75 12.6875V16.25H22.3125C22.4156 16.25 22.5 16.3344 22.5 16.4375V17.5625Z",
    fill: "#0040BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopupTable);
export default __webpack_public_path__ + "static/media/TopupTable.7f65e29c3182e62f7edaaf6db8e4f73d.svg";
export { ForwardRef as ReactComponent };